import { Link, useNavigate } from "react-router-dom";

import p_navbars from "../../Assets/Images/icons/navbar_light.png";
import p_nav_search from "../../Assets/Images/icons/navbar_search.png";
import p_booking_appointments from "../../Assets/Images/p_booking_appointments.svg";
import p_booking_messenger from "../../Assets/Images/p_booking_messenger.svg";
import p_bookings_resech from "../../Assets/Images/p_bookings_resech.svg";
import p_booking_loyalty from "../../Assets/Images/p_booking_loyalty.svg";
import p_bookings_makeItEasy from "../../Assets/Images/p_bookings_makeItEasy.svg";
import p_bookings_connect from "../../Assets/Images/p_bookings_connect.svg";
import p_nav_next_outline from "../../Assets/Images/p_nav_next_outline.svg";
import p_nav_book_outline from "../../Assets/Images/p_nav_book_outline.svg";
import p_nav_message_outline from "../../Assets/Images/p_nav_message_outline.svg";
import p_nav_notifications_outline from "../../Assets/Images/p_nav_notifications_outline.svg";
import p_nav_about_outline from "../../Assets/Images/p_nav_about_outline.svg";
import p_nav_setting_outline from "../../Assets/Images/p_nav_setting_outline.svg";
import p_nav_location from "../../Assets/Images/icons/p_nav_light_location.png";
import no_ticket from "../../Assets/Images/icons/no_ticket.png"
import { FaExclamation } from "react-icons/fa";
import FooterButton from '../../Assets/Images/FooterButton.png';
import pingleLogoWhite from '../../Assets/Images/Pingle-Logo_White-62.png';
import { IoIosArrowDropupCircle } from "react-icons/io";
import { IoIosArrowDropdownCircle } from "react-icons/io";
import { useEffect, useRef, useState } from "react";
import { addRecentLocation, getBookingList, getMyLocations, getMyProfileDetails, notificationCounts } from "../../Services/api";
import axiosInstance from "../../Services/axios";
import AppointmentProductCard from "../../Components/appointment_card/AppointmentProductCard";
import AppointmentServiceCard from "../../Components/appointment_card/AppointmentServiceCard";
import dayjs from 'dayjs';
import { FaArrowRightLong } from "react-icons/fa6";
import { FaArrowLeftLong } from "react-icons/fa6";
import Side_Bar from "../../Components/SideBar/Side_Bar";
import NodeaxiosInstance from "../../Services/nodeaxios";
import AppointmentKitchenCard from "../../Components/appointment_card/AppointmentKitchenCard";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { IoIosArrowForward } from "react-icons/io";
import { HiTicket } from "react-icons/hi2";
import Lottie from "lottie-react";
import empotyLottie from "../../Assets/lottieFiles/emptybookingmanager.json"
import { RiChatHistoryLine } from "react-icons/ri";
import ViewHistoryBtn from "../../Components/buttons/viewHistorybtn";
import { useSelector } from "react-redux";
import PingleFooter from "../../Components/Footer/pingleFooter";
import { useCheckLogin } from "../../routes/checkLogin";

// Creation time of a card (backend `sort_time`: product order_date, hub created_date, service booking_created_at).
// Used for every Booking Manager sort so the most recently created card is always first, whatever its type.
const getSortTime = (item) => {
    const time = new Date(item?.sort_time).getTime();
    return Number.isNaN(time) ? 0 : time;
};

const BookingsManager = () => {
    useCheckLogin()
    const yetTopayRef = useRef(null);
    const state = useSelector((state) => state);
    const [userData, serUserData] = useState(state?.userAuth?.user);
    const [isOpen, setIsOpen] = useState(true);
    const [profile, setProfileData] = useState("");
    const [bookingDetails, setBookingDetails] = useState("");
    const [activeTab, setActiveTab] = useState("");
    const [userOrders, setUserOrders] = useState([]);
    const [unconfirmed, setUnconfirmed] = useState([])
    const [todayproduct, setTodayproduct] = useState([])
    const [upcomingproduct, setUpcomingproduct] = useState([])
    const [missedService, setMissedSeivice] = useState([])
    const [servicetabcategory, setServiceTabcategory] = useState('')
    const [producttabcategory, setProductTabcategory] = useState('')
    const [notificationcount, setNotificationcount] = useState("");
    const [openIndices, setOpenIndices] = useState([1, 2, 3]);
    const [vendorTypes, setVendorTypes] = useState([]);
    const [fil_location, set_fil_location] = useState('');
    const [locationsList, setLocationsList] = useState([]);


    const [foodtabcategory, setFoodTabcategory] = useState('')
    const [foodlistalltab, setFoodlistAlltab] = useState([])
    const [foodtoday_list, setFoodtoday_list] = useState([])
    const [foodupcoming_list, setFoodupcoming_list] = useState([])

    const [alltabcategory, setAlltabcategory] = useState('')
    const [allTab_product_service, setAllTab_product_service] = useState([]);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [cartData, setCartDate] = useState('')
    const navigate = useNavigate();
    let [allAppointmentList, setAllAppointmentList] = useState([]);



    const [showPaymentSuccessModal, setShowPaymentSuccessModal] = useState(false);

    const handlePaySuccessClose = () => setShowPaymentSuccessModal(false);
    const handlePaySuccessShow = () => setShowPaymentSuccessModal(true);
    const [appointmentDetails, setAppointmentDetails] = useState([]);

    useEffect(() => {
        if (userData?.user_type === "Guest") {
            navigate("/search-store");
            return;
        }
        if (!userData?.token || userData?.token == "" || userData?.user_type != "User") {
            navigate("/login", { state: { fromGuest: true } });
            localStorage.removeItem('login')
            return;
        }

        getBookingList().then((res) => {
            setBookingDetails(res.data);
            setMissedSeivice(res.data?.missed_appointment_details);

            const combinedData = [
                ...(res.data?.unconfirmed_appointment_details || []),
                ...(res.data?.active_appointment_details || []),
                ...(res.data?.upcoming_appointment_details || []),
                ...(res.data?.missed_appointment_details || []),
            ];

            const parseDate = getSortTime;

            combinedData.sort((a, b) => parseDate(b) - parseDate(a));

            setAppointmentDetails(combinedData);
            const mergedAppointments = [
                ...allAppointmentList,
                ...(res.data?.unconfirmed_appointment_details || []),
                ...(res.data?.active_appointment_details || []),
                ...(res.data?.upcoming_appointment_details || []),
                ...(res.data?.missed_appointment_details || []),
            ];

            // Remove items where status = 2
            let filteredAppointments = mergedAppointments.filter(item => item.status != 2);

            filteredAppointments.sort((a, b) => parseDate(b) - parseDate(a));

            setAllAppointmentList(filteredAppointments);

        });

        getMyProfileDetails().then((res) => {
            setProfileData(res.data?.user_details);
        });
        notificationCounts().then((res) => {

            setNotificationcount(res.data);
        });
        getIndex();

        ["serviceDetail", "serviceAdded", "productAdded", "EditOrder_Detail",
            "localStorageserviceTime", "shipping_type", "productDeliveryTime", "cartid", "appliedCard",
            "cart_items", "productCart", "loyaltyDetail", "additionalNotes", "audioDuration",
            "deliveryInstructions", "recordedAudio", "recordedAudioUrl", "recoredURL",
            "dashboardtab", "vendortype", "bookingConfirm", "seletedPayType", "vendorUrl",
        ].forEach((key) => localStorage.removeItem(key));

        sessionStorage.removeItem("membership");


    }, []);


    function removeExtraFadeFromOffcanvas() {
        const myOffcanvas = document.getElementById('offcanvasTop');
        myOffcanvas.addEventListener('shown.bs.offcanvas', event => {
            let fade = document.getElementsByClassName('offcanvas-backdrop fade show')
            for (let i = 0; i < fade.length; i++) {
                while (fade.length > 1) {
                    fade[i].remove()
                }
            }
        });
    }


    const getIndex = async () => {
        try {


            const headers = { Authorization: userData?.token };
            const filterRes = await NodeaxiosInstance.get("/search-filter", { headers });
            const updatedVendorTypes = filterRes.data.vendor_type.map((item) => ({
                ...item,
                isSelected: false,
            }));

            setVendorTypes(updatedVendorTypes);



            const [productRes, kitchenRes] = await Promise.all([
                NodeaxiosInstance.get("/product/index"),
                NodeaxiosInstance.get('/kitchen/orders', {
                    headers: { Authorization: userData?.token }
                })
            ]);

            const data = productRes.data;

            if (!data?.user_detail?.user_id) {
                localStorage.removeItem('user');
                localStorage.removeItem('login');
                return navigate('/login', { state: { fromGuest: true } });
            }

            let userOrders = (data.user_orders || []).map(o => ({ ...o, type: "ORDER" }));
            let unconfirmedOrders = (data.unconfirmed_orders || []).map(o => ({ ...o, type: "CART" }));

            let kitchenOrders = kitchenRes.data.orders || [];
            kitchenOrders.sort((a, b) => getSortTime(b) - getSortTime(a));

            let todayticket = [];
            let upcomingticket = [];

            kitchenOrders.forEach(tab => {
                if (tab.delivery_status == "2" || tab.delivery_status == "4") todayticket.push(tab);
                else if (tab.delivery_status == "1") upcomingticket.push(tab);
            });

            todayticket.sort((a, b) => getSortTime(b) - getSortTime(a));
            upcomingticket.sort((a, b) => getSortTime(b) - getSortTime(a));

            let allOrders = [...unconfirmedOrders, ...userOrders, ...kitchenOrders];
            const parseDate = getSortTime;
            allOrders.sort((a, b) => parseDate(b) - parseDate(a));

            setFoodtoday_list(todayticket);
            setFoodupcoming_list(upcomingticket);
            setUnconfirmed(unconfirmedOrders);
            setUserOrders(allOrders);

            let todayProduct = [];
            let upcomingProduct = [];

            data.user_orders.forEach(tab => {
                if (tab.delivery_status == "2" || tab.delivery_status == "4") todayProduct.push(tab);
                else if (tab.delivery_status == "1") upcomingProduct.push(tab);
            });

            todayProduct.sort((a, b) => parseDate(b) - parseDate(a));
            upcomingProduct.sort((a, b) => parseDate(b) - parseDate(a));

            setTodayproduct(todayProduct);
            setUpcomingproduct(upcomingProduct);
            setTimeout(() => {
                setPageLoaded(true)
            }, 1000);
        } catch (error) {
            console.error(error);
        }
    };


    const openYettopayModal = (item) => {
        yetTopayRef.current.classList.add("show");
        yetTopayRef.current.style.display = "block";
        setCartDate(item)
    };

    const closeYettopayModal = () => {
        yetTopayRef.current.classList.remove("show");
    };

    const handleTabChange = (type, value) => {
        let tabDetail = JSON.parse(sessionStorage.getItem('tabDetail')) || {
            ActiveTab: activeTab,
            Servicecategory: servicetabcategory,
            Productcategory: producttabcategory,
            Alltabcategory: alltabcategory,
        };

        if (type === 'ActiveTab') {
            setActiveTab(value);
            tabDetail.ActiveTab = value;
        } else if (type === 'Servicecategory') {
            setServiceTabcategory(value);
            tabDetail.Servicecategory = value;
        } else if (type === 'Productcategory') {
            setProductTabcategory(value);
            tabDetail.Productcategory = value;
        } else if (type === 'Alltabcategory') {
            setAlltabcategory(value);
            tabDetail.Alltabcategory = value;
        }
        sessionStorage.setItem('tabDetail', JSON.stringify(tabDetail));
    };

    useEffect(() => {
        let localActivetab = JSON.parse(sessionStorage.getItem("tabDetail"));
        if (localActivetab) {
            setProductTabcategory(localActivetab.Productcategory || "pills-all-tab");
            setServiceTabcategory(localActivetab.Servicecategory || "pills-all-services");
            setAlltabcategory(localActivetab.Alltabcategory || "pills-all-tab");
            setActiveTab(localActivetab.ActiveTab || "Alltabcategory");
            setFoodTabcategory(localActivetab.Foodcategory || "pills-all-tab")
        } else {
            setProductTabcategory("pills-all-tab");
            setServiceTabcategory("pills-all-services");
            setAlltabcategory("pills-all-tab")
            setActiveTab("Alltabcategory");
            setFoodTabcategory("pills-all-tab")
        }
    }, []);

    const handelYettoPay = () => {
        let serviceDetail = {
            serviceType: cartData.book_service_type,
            vendorId: cartData.book_vendor_id,
            cart_app_id: cartData.cart_app_id
        }
        localStorage.setItem('serviceDetail', JSON.stringify(serviceDetail));
        navigate(`/review-and-pay/${cartData.book_vendor_id}`, { state: { fromPage: "bookingManager" } })

    }

    const [allTabb_today_list, setAllTabb_today_list] = useState([])
    const [allTabb_upcoming_list, setAllTabb_upcoming_list] = useState([])
    const [allTabb_unconfirmed_list, setAllTabb_unconfirmed_list] = useState([])

    useEffect(() => {

        const parseDate = getSortTime;

        let filteredAppointments = allAppointmentList.filter(item => item.status != 2);
        let combinedData = [...userOrders, ...filteredAppointments];
        combinedData.sort((a, b) => parseDate(b) - parseDate(a));


        setAllTab_product_service(combinedData)

        let NewallTab_today_list = [
            ...(bookingDetails.active_appointment_details || []),
            ...todayproduct
        ];
        NewallTab_today_list.sort((a, b) => parseDate(b) - parseDate(a));
        setAllTabb_today_list(NewallTab_today_list);

        let NewallTab_upcoming_list = [
            ...(bookingDetails?.upcoming_appointment_details || []),
            ...upcomingproduct
        ];
        NewallTab_upcoming_list.sort((a, b) => parseDate(b) - parseDate(a));
        setAllTabb_upcoming_list(NewallTab_upcoming_list);

        let NewallTab_unconfirmed_list = [
            ...(bookingDetails?.unconfirmed_appointment_details || []),
            ...unconfirmed
        ];
        NewallTab_unconfirmed_list.sort((a, b) => parseDate(b) - parseDate(a));
        setAllTabb_unconfirmed_list(NewallTab_unconfirmed_list);

    }, [userOrders, bookingDetails]);


    const recentOrders = (items) => {
        if (!Array.isArray(items)) {
            return [];
        }

        const sortedItems = items
            .map(item => {
                const date = item.order_date_string ? dayjs(item.order_date_string, "ddd Do MMM YYYY, hh:mm A") : item.book_date
                    ? dayjs(item.book_date, "MMMM, DD YYYY")
                    : null;

                return date ? { ...item, date } : null;
            })
            .filter(Boolean)
            .sort((a, b) => b.date - a.date);

        // Update state with the sorted items
        // setAllTab_product_service(sortedItems);

        return sortedItems;
    };

    function scrollTutorial(direction) {
        const scrollContainer = document.querySelector('.scroller-style-x-new');
        const scrollAmount = 200;

        if (direction === 'left') {
            scrollContainer.scrollLeft -= scrollAmount;
        } else if (direction === 'right') {
            scrollContainer.scrollLeft += scrollAmount;
        }
    }

    function tab_scroll_x(direction) {
        const scrollContainer = document.querySelector('.scroller-style-x');
        const scrollAmount = 200;

        if (direction === 'left') {
            scrollContainer.scrollLeft -= scrollAmount;
        } else if (direction === 'right') {
            scrollContainer.scrollLeft += scrollAmount;
        }
    }


    useEffect(() => {
        if (userData?.user_type == "User") {
            getMyLocations().then((res) => {
                setLocationsList(res.data?.saved_locations)

            });
            return;
        }

    }, []);

    const [location, setLocation] = useState({ lat: "", long: "" });

    useEffect(() => {
        let isCancelled = false;
        let checkstatus = localStorage.getItem("getlocation") ? JSON.parse(localStorage.getItem("getlocation")) : "";

        if (checkstatus?.model == false || checkstatus?.model == "false") {
            const newLocation = {
                latlng: checkstatus?.location?.location_coordinates,
                select_address: checkstatus?.location?.address,
                select_locality: checkstatus?.location?.locality

            };

            set_fil_location(newLocation);
        }
        else {
            const getLocation = async () => {
                // if (!("geolocation" in navigator)) { 
                navigator.geolocation.getCurrentPosition(
                    async (position) => {
                        if (isCancelled) return;

                        const { latitude, longitude } = position.coords;
                        const currentLoc = {
                            lat: latitude,
                            lng: longitude,
                            accuracy: position.coords.accuracy,
                        };

                        try {
                            const matches = findMatchingLocations(currentLoc, locationsList, 100);
                            if (matches && matches.length > 0) {
                                set_fil_location({
                                    "latlng": matches[0].latlng,
                                    "select_address": matches[0].address,
                                    "select_locality": matches[0].locality
                                });
                                return;
                            }

                            const addressData = await getAddressFromCoords(latitude, longitude);
                            const localityName = addressData?.address_components?.find(comp => comp.types.includes('locality'))?.long_name || '';
                            let lat = { latitude, longitude }


                            if (!isCancelled && matches.length == 0) {
                                set_fil_location({
                                    "latlng": `${lat.latitude},${lat.longitude}`,
                                    "select_address": addressData.formatted_address,
                                    "select_locality": localityName
                                });

                            }
                        } catch (error) {
                            console.log('err', error);

                            if (!isCancelled) {
                                return;
                            }
                        }
                    },
                    (err) => {
                        if (!isCancelled) {
                        }
                        return;
                    },
                    { enableHighAccuracy: true, timeout: 10000 }
                );
            };
            getLocation();
        }
        return () => {
            isCancelled = true;
        };

    }, [locationsList]);


    const parseLatLng = (latlngString) => {
        const [lat, lng] = latlngString.split(',').map(Number);
        return { lat, lng };
    };

    const calculateDistance = (lat1, lng1, lat2, lng2) => {
        const R = 6371e3;
        const φ1 = lat1 * Math.PI / 180;
        const φ2 = lat2 * Math.PI / 180;
        const Δφ = (lat2 - lat1) * Math.PI / 180;
        const Δλ = (lng2 - lng1) * Math.PI / 180;

        const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
            Math.cos(φ1) * Math.cos(φ2) *
            Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return R * c;
    };

    const findMatchingLocations = (currentLoc, locations, threshold) => {
        return locations
            .map(loc => {
                const savedLoc = parseLatLng(loc.latlng);

                const distance = calculateDistance(
                    currentLoc.lat, currentLoc.lng,
                    savedLoc.lat, savedLoc.lng
                );
                return { ...loc, distance };
            })
            .filter(loc => loc.distance <= threshold)
            .sort((a, b) => a.distance - b.distance);
    };

    const getAddressFromCoords = async (lat, lng) => {
        try {
            const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || process.env.REACT_APP_GOOGLE_MAPS_TEST_API_KEY;
            const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`);
            const data = await response.json();
            if (data.status === "OK" && data.results && data.results.length > 0) {
                return data.results[0];
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    // useEffect(() => {
    //     if ("geolocation" in navigator) {
    //         navigator.geolocation.getCurrentPosition(
    //             (position) => {
    //                 setLocation({
    //                     lat: position.coords.latitude,
    //                     long: position.coords.longitude,
    //                 });

    //             },
    //             (error) => {

    //             }
    //         );
    //     } else {

    //     }
    //     sessionStorage.removeItem('shouldOpenModal');
    //     localStorage.removeItem('getlocation');
    // }, []);

    const [showLogo, setShowLogo] = useState(false);

    useEffect(() => {
        // Small timeout to trigger animation after mount
        const timer = setTimeout(() => {
            setShowLogo(true);
        }, 50);
        return () => clearTimeout(timer);
    }, []);

    const toggleAccordion = (index) => {
        if (openIndices.includes(index)) {
            setOpenIndices(openIndices.filter((i) => i != index));
        } else {
            setOpenIndices([...openIndices, index]);
        }
    };

    return (
        <>



            <div className="d-flex justify-content-between align-items-center p-3 white-bg p-navbar booking-manager-nav offcanvas-parentType1">

                <div className="d-flex justify-content-between align-items-center">
                    <img src={p_navbars} width={"24px"} height={"16px"} role="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasTop" aria-controls="offcanvasTop" onClick={removeExtraFadeFromOffcanvas} />
                    <div className="ff-balooPaaji2-bold text-light fs-20 ms-2 ps-1"> Bookings Manager </div>
                </div>
                <img src={p_nav_search} width={"23px"} height={"23px"} onClick={() => navigate('/search-store', { state: { lat: location.lat, long: location.lat } })} />

                <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasTop" aria-labelledby="offcanvasTopLabel" >
                    <div className="offcanvas-body p-0">
                        <Link to={`/dashboard`} className="text-decoration-none">
                            <div className="profileDetails primary-bg p-3 text-white d-flex justify-content-between align-items-center">
                                <div className="d-flex">
                                    <img src={profile?.user_img} width={"84px"} height={"81px"} className="profile" />
                                    <div className="ms-2">
                                        <div className="ff-poppins-semiBold fs-16">
                                            {profile?.user_name}
                                        </div>
                                        <div className="ff-balooPaaji2-regular fs-12">
                                            UID:{profile?.user_id}
                                        </div>
                                        {profile?.user_city &&
                                            <div className="ff-balooPaaji2-regular fs-12">
                                                <img src={p_nav_location} width={"12px"} height={"12px"} className="me-1" />
                                                {profile?.user_city}
                                            </div>}
                                    </div>
                                </div>
                                <img src={p_nav_next_outline} width={"24px"} height={"24px"} />
                            </div>
                        </Link>

                        <div>
                            <div className="d-flex p-3" role="button" data-bs-dismiss="offcanvas" aria-label="Close"  >
                                <img src={p_nav_book_outline} width={"24px"} height={"24px"} />
                                <div className="ff-poppins-regular fs-16 ms-3">
                                    Bookings Manager
                                </div>
                            </div>

                            <Link
                                to={`/messenger-list`}
                                className="text-decoration-none text-dark"
                            >
                                <div className="d-flex p-3" role="button">
                                    <img src={p_nav_message_outline} width={"24px"} height={"24px"} />
                                    <div className="d-flex justify-content-between w-100">
                                        <div className="ff-poppins-regular fs-16 ms-3">Messenger</div>
                                        <p className="p-0 m-0">
                                            {notificationcount.unread_message_count > 0 ?
                                                <span className="notification_count">
                                                    {notificationcount.unread_message_count >= 9 ? "9+" : notificationcount.unread_message_count}
                                                </span> : <></>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </Link>

                            <div className="d-flex sidebar p-3 " role="button" onClick={() => navigate("/notifications", { state: { UserId: profile.user_id } })}>
                                <img src={p_nav_notifications_outline} width={"24px"} height={"24px"}
                                />
                                <div className="d-flex justify-content-between w-100">
                                    <div className="ff-poppins-regular fs-16 ms-3">
                                        Notification
                                    </div>
                                    <p className="">
                                        {notificationcount.unread_count > 0 ?
                                            <span className="notification_count">
                                                {notificationcount.unread_count >= 9 ? "9+" : notificationcount.unread_count}
                                            </span> : <></>
                                        }
                                    </p>
                                </div>
                            </div>

                            <Link to={`/aboutPingle`} className="text-decoration-none text-dark" >
                                <div className="d-flex p-3" role="button">
                                    <img src={p_nav_about_outline} width={"24px"} height={"24px"} />
                                    <div className="ff-poppins-regular fs-16 ms-3">
                                        About Pingle
                                    </div>
                                </div>
                            </Link>

                            <Link to={`/settings`} className="text-decoration-none text-dark">
                                <div className="d-flex p-3" role="button">
                                    <img
                                        src={p_nav_setting_outline}
                                        width={"24px"}
                                        height={"24px"}
                                    />
                                    <div className="ff-poppins-regular fs-16 ms-3">Settings</div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>

            </div>
            {
                pageLoaded ?
                    <>
                        <div className="bookingManager pb-5 scroller-style-y">
                            <div className="">
                                <div className="primary-bg header">
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <div className="ff-balooPaaji2-bold fs-20 text-light">Hello</div>
                                            <div className="ff-balooPaaji2-bold fs-20 text-light text-break" >
                                                {profile?.user_name}
                                            </div>
                                        </div>
                                    </div>
                                    {/* <img src={p_nav_location} width={"52px"} height={"52px"} className="me-1" /> */}


                                    <div className="ff-poppins-regular fs-13 text-light mt-2">
                                        Your Bookings
                                    </div>
                                </div>


                                {/* All,services and product  */}
                                <div className="subHeader ">

                                    <ul className="nav parent-nav  nav-pills py-3 fs-14" id="pills-tab" role="tablist" style={{ width: "100%" }} >
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className={`nav-link ${activeTab === "Alltabcategory" ? "active" : ""} rounded-start serviceProductTab allBtnBM ff-poppins-regular`}
                                                id="pills-Alltabcategory-tab" data-bs-toggle="pill" data-bs-target="#pills-Alltabcategory"
                                                type="button" role="tab" aria-controls="pills-Alltabcategory"
                                                aria-selected={activeTab === "Alltabcategory" ? "true" : "false"} onClick={() => handleTabChange("ActiveTab", "Alltabcategory")}  >
                                                All
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className={`nav-link ${activeTab === "services" ? "active" : ""} rounded-start serviceProductTab serviceBtnBM ff-poppins-regular`}
                                                id="pills-services-tab" data-bs-toggle="pill" data-bs-target="#pills-services"
                                                type="button" role="tab" aria-controls="pills-services"
                                                aria-selected={activeTab === "services" ? "true" : "false"} onClick={() => handleTabChange("ActiveTab", "services")}  >
                                                Services
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className={`nav-link ${activeTab === "products" ? "active" : ""} serviceProductTab rounded-end productBtnBM ff-poppins-regular`}
                                                id="    Aab" data-bs-toggle="pill" data-bs-target="#pills-products"
                                                type="button" role="tab" aria-controls="pills-products"
                                                aria-selected={activeTab === "products" ? "true" : "false"} onClick={() => handleTabChange("ActiveTab", "products")} >
                                                Products
                                            </button>
                                        </li>
                                        {/* <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${activeTab === "food" ? "active" : ""} serviceProductTab rounded-end productBtnBM ff-poppins-regular`}
                                            id="Aab" data-bs-toggle="pill" data-bs-target="#pills-food"
                                            type="button" role="tab" aria-controls="pills-food"
                                            aria-selected={activeTab === "food" ? "true" : "false"} onClick={() => handleTabChange("ActiveTab", "food")} >
                                            Food
                                        </button>
                                    </li> */}
                                    </ul>


                                    <div className="arrow-controls primary-bg d-flex justify-content-end ">
                                        <FaArrowLeftLong
                                            className="text-light me-2 mt-1 arrow-icon"
                                            onClick={() => tab_scroll_x("left")}
                                        />
                                        <FaArrowRightLong
                                            className="text-light me-2 mt-1 arrow-icon"
                                            onClick={() => tab_scroll_x("right")}
                                        />
                                    </div>

                                    {/* Seperate componant  */}
                                    <div className="tab-content " id="pills-tabContent">

                                        {activeTab === "Alltabcategory" &&
                                            <div className={`tab-pane fade ${activeTab === "Alltabcategory" ? "show active" : ""}`} id="pills-All" role="tabpanel" aria-labelledby="pills-All-tab">
                                                <ul className="appointmentFilter bookingManager-appointmentFilter scroller-style-x mouse_Default nav d-flex flex-nowrap nav-pills pt-2 pb-3" id="pills-tab" role="tablist">
                                                    <li className="nav-item " role="presentation">
                                                        <button className={`nav-link ${alltabcategory === "pills-all-tab" ? "active" : ""}`} id="pills-all-tab" data-bs-toggle="pill" data-bs-target="#pills-all"
                                                            type="button" role="tab" aria-controls="pills-all" onClick={() => handleTabChange("Alltabcategory", 'pills-all-tab')} aria-selected={alltabcategory === "pills-all-tab" ? "true" : "false"} >
                                                            All
                                                            {allTab_product_service.length > 0 &&
                                                                <span className={`booking-count ${alltabcategory === "pills-all-tab" ? 'bg-white' : 'primary-bg-medium text-light'}`}> {allTab_product_service.length}</span>
                                                            }
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button
                                                            className={`nav-link ${alltabcategory === "pills-today-tab" ? "active" : ""}`}
                                                            id="pills-today-tab"
                                                            data-bs-toggle="pill"
                                                            data-bs-target="#pills-today"
                                                            type="button"
                                                            role="tab"
                                                            aria-controls="pills-today"
                                                            onClick={() => handleTabChange("Alltabcategory", 'pills-today-tab')}
                                                            aria-selected={alltabcategory === "pills-today-tab" ? "true" : "false"}
                                                        >
                                                            Today
                                                            {allTabb_today_list.length > 0 &&
                                                                <span className={`booking-count ${alltabcategory === "pills-today-tab" ? 'bg-white' : 'primary-bg-medium text-light'}`}> {allTabb_today_list.length}</span>
                                                            }
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button
                                                            className={`nav-link ${alltabcategory === "pills-upcoming-tab" ? "active" : ""}`}
                                                            id="pills-upcoming-tab"
                                                            data-bs-toggle="pill"
                                                            data-bs-target="#pills-upcoming"
                                                            type="button"
                                                            role="tab"
                                                            aria-controls="pills-upcoming"
                                                            onClick={() => handleTabChange("Alltabcategory", 'pills-upcoming-tab')}
                                                            aria-selected={alltabcategory === "pills-upcoming-tab" ? "true" : "false"}
                                                        >
                                                            Upcoming
                                                            {allTabb_upcoming_list.length > 0 &&
                                                                <span className={`booking-count ${alltabcategory === "pills-upcoming-tab" ? 'bg-white' : 'primary-bg-medium text-light'}`}> {allTabb_upcoming_list.length}</span>
                                                            }
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button
                                                            className={`nav-link ${alltabcategory === "pills-unconfirmed-tab" ? "active" : ""}`}
                                                            id="pills-unconfirmed-tab"
                                                            data-bs-toggle="pill"
                                                            data-bs-target="#pills-unconfirmed"
                                                            type="button"
                                                            role="tab"
                                                            aria-controls="pills-unconfirmed"
                                                            onClick={() => handleTabChange("Alltabcategory", 'pills-unconfirmed-tab')}
                                                            aria-selected={alltabcategory === "pills-unconfirmed-tab" ? "true" : "false"}
                                                        >
                                                            Unconfirmed
                                                            {allTabb_unconfirmed_list.length > 0 &&
                                                                <span className={`booking-count ${alltabcategory === "pills-unconfirmed-tab" ? 'bg-white' : 'primary-bg-medium text-light'}`}> {allTabb_unconfirmed_list.length}</span>
                                                            }
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button
                                                            className={`nav-link ${alltabcategory === "pills-missed-tab" ? "active" : ""}`}
                                                            id="pills-missed-tab"
                                                            data-bs-toggle="pill"
                                                            data-bs-target="#pills-missed"
                                                            type="button"
                                                            role="tab"
                                                            aria-controls="pills-missed"
                                                            onClick={() => handleTabChange("Alltabcategory", 'pills-missed-tab')}
                                                            aria-selected={alltabcategory === "pills-missed-tab" ? "true" : "false"}
                                                        >
                                                            Missed
                                                            {bookingDetails?.missed_appointment_details?.length > 0 &&
                                                                <span className={`booking-count ${alltabcategory === "pills-missed-tab" ? 'bg-white' : 'primary-bg-medium text-light'}`}> {bookingDetails?.missed_appointment_details?.length}</span>
                                                            }
                                                        </button>
                                                    </li>
                                                </ul>

                                                <div class="tab-content pe-3 ps-3" id="pills-tabContent">
                                                    <div className={`tab-pane fade ${alltabcategory === "pills-all-tab" ? "show active" : ""}`} id="pills-all" role="tabpanel" aria-labelledby="pills-all-tab" tabIndex="0">
                                                        {allTab_product_service?.length > 0 ? (
                                                            allTab_product_service.map((item, index) => {
                                                                return (
                                                                    <div className="tab-pane mt-2" key={index} id="pills-all-tab" role="tabpanel" aria-labelledby="pills-all-tab" >
                                                                        <div onClick={() => {
                                                                            if (item.order_id) {
                                                                                if (item.type == 'CART') {
                                                                                    navigate("/ReviewPay", { state: { merchantId: item.vendor_id, shipingtype: item.shipping_type, orderType: "booknow" }, })
                                                                                    let productCart = {
                                                                                        cartId: item.cart_id,
                                                                                        shipping_type: item.shipping_type,
                                                                                        vendorId: item.vendor_id
                                                                                    };
                                                                                    localStorage.setItem("productCart", JSON.stringify(productCart));
                                                                                }
                                                                                else if (item.kitchen_id) {
                                                                                    navigate(`/order-pass/${item.order_id}`)
                                                                                }
                                                                                else {
                                                                                    navigate(`/ProductPass/${item.order_id}`)
                                                                                }
                                                                            }
                                                                            else if (!item.order_id && item.order_status == "") {
                                                                                navigate("/ReviewPay", { state: { merchantId: item.vendor_id, shipingtype: item.shipping_type, orderType: "booknow" }, })
                                                                                let productCart = {
                                                                                    cartId: item.cart_id,
                                                                                    shipping_type: item.shipping_type,
                                                                                    vendorId: item.vendor_id
                                                                                };
                                                                                localStorage.setItem("productCart", JSON.stringify(productCart));
                                                                            }
                                                                            else if (item.booking_id || item.book_status == '5') {
                                                                                if (item.book_status == '5') {
                                                                                    if (((Number(item.book_service_type) == 2 && Number(item.doorstep_request_status) == 2) || Number(item.book_service_type) == 1)) {
                                                                                        openYettopayModal(item)
                                                                                    } else {
                                                                                        let serviceDetail = {
                                                                                            serviceType: item.book_service_type,
                                                                                            vendorId: item.book_vendor_id,
                                                                                            cart_app_id: item.cart_app_id
                                                                                        }
                                                                                        localStorage.setItem('serviceDetail', JSON.stringify(serviceDetail));
                                                                                        navigate(`/review-and-pay/${item.book_vendor_id}`, { state: { fromPage: "bookingManager" } })
                                                                                    }
                                                                                }
                                                                                else { navigate(`/details/${item.booking_id}`); }
                                                                            }
                                                                        }}>
                                                                            {
                                                                                item.booking_id || item.book_status == "5" ? <AppointmentServiceCard data={item} /> :
                                                                                    item.kitchen_id ? <AppointmentKitchenCard data={item} /> :
                                                                                        <AppointmentProductCard data={item} />
                                                                            }

                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                        ) : (
                                                            <>
                                                                <div>
                                                                    <Lottie animationData={empotyLottie} />
                                                                </div>
                                                                <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-1">
                                                                    <HiTicket className="bmno-ticket" />   No service / product booking
                                                                </div>
                                                                <ViewHistoryBtn />
                                                            </>
                                                        )}
                                                    </div>
                                                    <div className={`tab-pane fade ${alltabcategory === "pills-complete-tab" ? "show active" : ""}`} id="pills-today" role="tabpanel" aria-labelledby="pills-today-tab" tabindex="0" >
                                                        {
                                                            allTabb_today_list?.length > 0 ?
                                                                allTabb_today_list.map((item, subindex) => {
                                                                    return (
                                                                        <div onClick={() => {
                                                                            if (item.order_id) {
                                                                                navigate(`/ProductPass/${item.order_id}`)
                                                                            }
                                                                            else if (item.booking_id) {
                                                                                navigate(`/details/${item.booking_id}`)
                                                                            }
                                                                        }} key={subindex}>
                                                                            {
                                                                                item.order_id ? <AppointmentProductCard data={item} /> : <AppointmentServiceCard data={item} />
                                                                            }
                                                                        </div>
                                                                    );
                                                                }) :
                                                                <>
                                                                    <div>
                                                                        <Lottie animationData={empotyLottie} />
                                                                    </div>
                                                                    <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-1">
                                                                        <HiTicket className="bmno-ticket" />   No service / product booking today
                                                                    </div>
                                                                    <ViewHistoryBtn />
                                                                </>
                                                        }
                                                    </div>

                                                    <div className={`tab-pane fade ${alltabcategory === "pills-cancel-tab" ? "show active" : ""}`} id="pills-upcoming" role="tabpanel" aria-labelledby="pills-upcoming-tab" tabindex="0" >
                                                        {
                                                            allTabb_upcoming_list?.length > 0 ?
                                                                allTabb_upcoming_list.map((item, subindex) => {
                                                                    return (
                                                                        <div onClick={() => {
                                                                            if (item.order_id) {
                                                                                navigate(`/ProductPass/${item.order_id}`)
                                                                            } else if (item.booking_id) {
                                                                                navigate(`/details/${item.booking_id}`)
                                                                            }
                                                                        }} key={subindex}>
                                                                            {
                                                                                item.order_id ? <AppointmentProductCard data={item} /> : <AppointmentServiceCard data={item} />
                                                                            }
                                                                        </div>
                                                                    )
                                                                }) :
                                                                <>
                                                                    <div>
                                                                        <Lottie animationData={empotyLottie} />
                                                                    </div>
                                                                    <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-1">
                                                                        <HiTicket className="bmno-ticket" />   No upcoming service / product booking
                                                                    </div>
                                                                    <ViewHistoryBtn />
                                                                </>
                                                            // <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-4">
                                                            //     <HiTicket className="bmno-ticket" />   No upcoming service / product Booking
                                                            // </div>


                                                        }
                                                    </div>

                                                    <div className={`tab-pane fade ${alltabcategory === "pills-expired-tab" ? "show active" : ""}`} id="pills-unconfirmed" role="tabpanel" aria-labelledby="pills-unconfirmed-tab" tabindex="0" >
                                                        {

                                                            allTabb_unconfirmed_list?.length > 0 ?
                                                                allTabb_unconfirmed_list.map((item, subindex) => {
                                                                    return (
                                                                        <>
                                                                            <div onClick={() => {
                                                                                if (item.order_products) {
                                                                                    navigate("/ReviewPay", { state: { merchantId: item.vendor_id, shipingtype: item.shipping_type, orderType: "booknow" }, })
                                                                                    let productCart = {
                                                                                        cartId: item.cart_id,
                                                                                        shipping_type: item.shipping_type,
                                                                                        vendorId: item.vendor_id
                                                                                    };
                                                                                    localStorage.setItem("productCart", JSON.stringify(productCart));
                                                                                } else if (item.booking_id || item.book_status == '5') {
                                                                                    openYettopayModal(item)
                                                                                }
                                                                            }} key={subindex}>
                                                                                {
                                                                                    item.order_products ? <AppointmentProductCard data={item} /> : <AppointmentServiceCard data={item} />
                                                                                }

                                                                            </div>

                                                                        </>
                                                                    );
                                                                }) :
                                                                <>
                                                                    <div>
                                                                        <Lottie animationData={empotyLottie} />
                                                                    </div>
                                                                    <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-1">
                                                                        <HiTicket className="bmno-ticket" />   No unconfirmed service / product booking
                                                                    </div>
                                                                    <ViewHistoryBtn />
                                                                </>
                                                            // <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-4">
                                                            //     <HiTicket className="bmno-ticket" />    No unconfirmed service / product booking
                                                            // </div>
                                                        }
                                                    </div>
                                                    <div className={`tab-pane fade ${alltabcategory === "pills-missed-tab" ? "show active" : ""}`} id="pills-missed" role="tabpanel" aria-labelledby="pills-missed-tab" tabindex="0" >
                                                        {bookingDetails?.missed_appointment_status ? (
                                                            bookingDetails?.missed_appointment_details.map((item, index) => {
                                                                return (
                                                                    <div onClick={() => navigate(`/details/${item.booking_id}`)} key={index} >
                                                                        <AppointmentServiceCard data={item} />
                                                                    </div>
                                                                );
                                                            })
                                                        ) : (
                                                            <>
                                                                <div>
                                                                    <Lottie animationData={empotyLottie} />
                                                                </div>
                                                                <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-1">
                                                                    <HiTicket className="bmno-ticket" />   No missed service / product booking
                                                                </div>
                                                                <ViewHistoryBtn />
                                                            </>
                                                            // <div className="text-center ff-poppins-regular fs-14 secondary-text pt-4">
                                                            //     <HiTicket className="bmno-ticket" />     No missed service appointments
                                                            // </div>
                                                        )}
                                                    </div>

                                                </div>
                                            </div>
                                        }

                                        {/*For Service */}

                                        {activeTab === "services" &&
                                            <div className={`tab-pane fade ${activeTab == "services" ? "show active" : ""}`} id="pills-services" role="tabpanel" aria-labelledby="pills-services-tab">
                                                <ul className="appointmentFilter bookingManager-appointmentFilter scroller-style-x mouse_Default nav d-flex flex-nowrap nav-pills pt-2 pb-3" id="pills-services-tab" role="tablist">
                                                    <li className="nav-item" role="presentation">
                                                        <div className={`nav-link ${servicetabcategory == "pills-all-services" ? "active" : ""}`}
                                                            id="pills-all-services-tab" data-bs-toggle="pill" data-bs-target="#pills-all-services"
                                                            type="button" role="tab" aria-controls="pills-all-services"
                                                            onClick={() => handleTabChange("Servicecategory", 'pills-all-services')}
                                                            aria-selected={servicetabcategory == "pills-all-services" ? "true" : "false"}
                                                        >
                                                            All
                                                            {allAppointmentList.length > 0 &&
                                                                <span className={`booking-count ${servicetabcategory == "pills-all-services" ? 'bg-white' : 'primary-bg-medium text-light'}`}> {allAppointmentList?.length}</span>
                                                            }
                                                        </div>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <div className={`nav-link ${servicetabcategory == "pills-today-services-tab" ? "active" : ""}`}
                                                            id="pills-today-services-tab" data-bs-toggle="pill" data-bs-target="#pills-today-services"
                                                            type="button" role="tab" aria-controls="pills-today-services"
                                                            onClick={() => handleTabChange("Servicecategory", 'pills-today-services-tab')}
                                                            aria-selected={servicetabcategory == "pills-today-services-tab" ? "true" : "false"}
                                                        >
                                                            Today
                                                            {bookingDetails?.active_appointment_details.length > 0 &&
                                                                <span className={`booking-count ${servicetabcategory == "pills-today-services-tab" ? 'bg-white' : 'primary-bg-medium text-light'}`}> {bookingDetails?.active_appointment_details.length}</span>
                                                            }
                                                        </div>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <div className={`nav-link ${servicetabcategory == "pills-upcoming-services-tab" ? "active" : ""}`}
                                                            id="pills-upcoming-services-tab" data-bs-toggle="pill" data-bs-target="#pills-upcoming-services"
                                                            type="button" role="tab" aria-controls="pills-upcoming-services"
                                                            onClick={() => handleTabChange("Servicecategory", 'pills-upcoming-services-tab')}
                                                            aria-selected={servicetabcategory == "pills-upcoming-services-tab" ? "true" : "false"}
                                                        >
                                                            Upcoming
                                                            {bookingDetails?.upcoming_appointment_details.length > 0 &&
                                                                <span className={`booking-count ${servicetabcategory == "pills-upcoming-services-tab" ? 'bg-white' : 'primary-bg-medium text-light'}`}> {bookingDetails?.upcoming_appointment_details.length}</span>
                                                            }
                                                        </div>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <div className={`nav-link ${servicetabcategory == "pills-unconfirmed-services-tab" ? "active" : ""}`}
                                                            id="pills-unconfirmed-services-tab" data-bs-toggle="pill" data-bs-target="#pills-unconfirmed-services"
                                                            type="button" role="tab" aria-controls="pills-unconfirmed-services"
                                                            onClick={() => handleTabChange("Servicecategory", 'pills-unconfirmed-services-tab')}
                                                            aria-selected={servicetabcategory == "pills-unconfirmed-services-tab" ? "true" : "false"}
                                                        >
                                                            Unconfirmed
                                                            {bookingDetails?.unconfirmed_appointment_details?.length > 0 &&
                                                                <span className={`booking-count ${servicetabcategory == "pills-unconfirmed-services-tab" ? 'bg-white' : 'primary-bg-medium text-light'}`}> {bookingDetails?.unconfirmed_appointment_details?.length}</span>
                                                            }
                                                        </div>
                                                    </li>

                                                    <li className="nav-item" role="presentation">
                                                        <div className={`nav-link ${servicetabcategory == "pills-missed-services-tab" ? "active" : ""}`}
                                                            id="pills-missed-services-tab" data-bs-toggle="pill" data-bs-target="#pills-missed-services"
                                                            type="button" role="tab" aria-controls="pills-missed-services"
                                                            onClick={() => handleTabChange("Servicecategory", 'pills-missed-services-tab')}
                                                            aria-selected={servicetabcategory == "pills-missed-services-tab" ? "true" : "false"} >
                                                            Missed
                                                            {bookingDetails?.missed_appointment_details.length > 0 &&
                                                                <span className={`booking-count ${servicetabcategory == "pills-missed-services-tab" ? 'bg-white' : 'primary-bg-medium text-light'}`}> {bookingDetails?.missed_appointment_details.length}</span>
                                                            }
                                                        </div>
                                                    </li>
                                                </ul>
                                                <div className="pe-3 ps-3">
                                                    <div className={`tab-pane  fade ${servicetabcategory == "pills-all-services" ? "show active" : ""}`} id="pills-all-services" role="tabpanel" aria-labelledby="pills-all-services-tab"    >
                                                        {
                                                            allAppointmentList?.length > 0 ?
                                                                allAppointmentList.map((item, index) => {
                                                                    return (
                                                                        <div className="" onClick={() => {
                                                                            if (item.book_status == '5') {
                                                                                if (((Number(item.book_service_type) == 2 && Number(item.doorstep_request_status) == 2) || Number(item.book_service_type) == 1)) {
                                                                                    openYettopayModal(item)
                                                                                } else {
                                                                                    let serviceDetail = {
                                                                                        serviceType: item.book_service_type,
                                                                                        vendorId: item.book_vendor_id,
                                                                                        cart_app_id: item.cart_app_id
                                                                                    }
                                                                                    localStorage.setItem('serviceDetail', JSON.stringify(serviceDetail));
                                                                                    navigate(`/review-and-pay/${item.book_vendor_id}`, { state: { fromPage: "bookingManager" } })
                                                                                }
                                                                            } else { navigate(`/details/${item.booking_id}`); }


                                                                        }} key={index}>
                                                                            <AppointmentServiceCard data={item} />

                                                                        </div>
                                                                    )
                                                                })
                                                                :
                                                                // <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-4">
                                                                //     <HiTicket className="bmno-ticket" />   No service appointments
                                                                // </div>
                                                                <>
                                                                    <div>
                                                                        <Lottie animationData={empotyLottie} />
                                                                    </div>
                                                                    <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-1">
                                                                        <HiTicket className="bmno-ticket" />   No service appointments
                                                                    </div>
                                                                    <ViewHistoryBtn />
                                                                </>
                                                        }
                                                    </div>
                                                    <div className={`tab-pane fade ${servicetabcategory == "pills-today-services-tab" ? "show active" : ""}`} id="pills-today-services-tab" role="tabpanel" aria-labelledby="pills-today-services-tab" >
                                                        {
                                                            bookingDetails?.active_appointment_status ?
                                                                bookingDetails?.active_appointment_details.map(item => {
                                                                    return (
                                                                        <div onClick={() => navigate(`/details/${item.booking_id}`)}>
                                                                            <AppointmentServiceCard data={item} />
                                                                        </div>
                                                                    )
                                                                })
                                                                :
                                                                // <div className="text-center ff-poppins-regular fs-14 secondary-text pt-4">
                                                                //     <HiTicket className="bmno-ticket" />    No service appointments today
                                                                // </div>
                                                                <>
                                                                    <div>
                                                                        <Lottie animationData={empotyLottie} />
                                                                    </div>
                                                                    <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-1">
                                                                        <HiTicket className="bmno-ticket" />   No service appointments today
                                                                    </div>
                                                                    <ViewHistoryBtn />
                                                                </>
                                                        }
                                                    </div>
                                                    <div className={`tab-pane fade ${servicetabcategory == "pills-unconfirmed-services-tab" ? "show active" : ""}`} id="pills-unconfirmed-services-tab" role="tabpanel" aria-labelledby="pills-unconfirmed-services-tab" >
                                                        {
                                                            bookingDetails?.unconfirmed_appointment_details?.length > 0 ? bookingDetails?.unconfirmed_appointment_details.map(item => {
                                                                return (
                                                                    <div onClick={() => openYettopayModal(item)}>
                                                                        <AppointmentServiceCard data={item} />

                                                                    </div>
                                                                )
                                                            })
                                                                :
                                                                // <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-4">
                                                                //     <HiTicket className="bmno-ticket" />    No unconfirmed service appointments
                                                                // </div>
                                                                <>
                                                                    <div>
                                                                        <Lottie animationData={empotyLottie} />
                                                                    </div>
                                                                    <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-1">
                                                                        <HiTicket className="bmno-ticket" />   No unconfirmed service
                                                                    </div>
                                                                    <ViewHistoryBtn />
                                                                </>
                                                        }
                                                    </div>
                                                    <div className={`tab-pane fade  ${servicetabcategory == "pills-upcoming-services-tab" ? "show active" : ""}`} id="pills-upcoming-services-tab" role="tabpanel" aria-labelledby="pills-upcoming-services-tab"  >
                                                        {
                                                            bookingDetails?.upcoming_appointment_status ?
                                                                bookingDetails?.upcoming_appointment_details.map(item => {
                                                                    return (
                                                                        <div onClick={() => navigate(`/details/${item.booking_id}`)}>
                                                                            <AppointmentServiceCard data={item} />
                                                                        </div>
                                                                    )
                                                                })
                                                                :
                                                                // <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-4">
                                                                //     <HiTicket className="bmno-ticket" />    No upcoming service appointments
                                                                // </div>
                                                                <>
                                                                    <div>
                                                                        <Lottie animationData={empotyLottie} />
                                                                    </div>
                                                                    <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-1">
                                                                        <HiTicket className="bmno-ticket" />   No upcoming service appointments
                                                                    </div>
                                                                    <ViewHistoryBtn />
                                                                </>
                                                        }
                                                    </div>
                                                    <div className={`tab-pane fade ${servicetabcategory == "pills-missed-services-tab" ? "show active" : ""}`} id="pills-missed-services-tab" role="tabpanel" aria-labelledby="pills-missed-services-tab" >
                                                        {bookingDetails?.missed_appointment_status ? (
                                                            bookingDetails?.missed_appointment_details.map((item) => {
                                                                return (
                                                                    <div onClick={() => navigate(`/details/${item.booking_id}`)}  >
                                                                        <AppointmentServiceCard data={item} />
                                                                    </div>
                                                                );
                                                            })
                                                        ) : (
                                                            // <div className="text-center ff-poppins-regular fs-14 secondary-text pt-4">
                                                            //     <HiTicket className="bmno-ticket" />     No missed service appointments
                                                            // </div>
                                                            <>
                                                                <div>
                                                                    <Lottie animationData={empotyLottie} />
                                                                </div>
                                                                <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-1">
                                                                    <HiTicket className="bmno-ticket" />   No missed service appointments
                                                                </div>
                                                                <ViewHistoryBtn />
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {/* For products  */}
                                        {activeTab === "products" &&
                                            <div className={`tab-pane fade ${activeTab === "products" ? "show active" : ""}`} id="pills-products" role="tabpanel" aria-labelledby="pills-products-tab">
                                                <ul className="appointmentFilter bookingManager-appointmentFilter scroller-style-x mouse_Default nav d-flex flex-nowrap nav-pills pt-2 pb-3" id="pills-tab" role="tablist">
                                                    <li className="nav-item" role="presentation">
                                                        <button
                                                            className={`nav-link ${producttabcategory === "pills-all-tab" ? "active" : ""}`}
                                                            id="pills-all-tab"
                                                            data-bs-toggle="pill"
                                                            data-bs-target="#pills-all"
                                                            type="button"
                                                            role="tab"
                                                            aria-controls="pills-all"
                                                            onClick={() => handleTabChange("Productcategory", 'pills-all-tab')}
                                                            aria-selected={producttabcategory === "pills-all-tab" ? "true" : "false"}
                                                        >
                                                            All
                                                            {userOrders.length > 0 &&
                                                                <span className={`booking-count ${producttabcategory === "pills-all-tab" ? 'bg-white' : 'primary-bg-medium text-light'}`}> {userOrders.length}</span>
                                                            }
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button
                                                            className={`nav-link ${producttabcategory === "pills-today-tab" ? "active" : ""}`}
                                                            id="pills-today-tab"
                                                            data-bs-toggle="pill"
                                                            data-bs-target="#pills-today"
                                                            type="button"
                                                            role="tab"
                                                            aria-controls="pills-today"
                                                            onClick={() => handleTabChange("Productcategory", 'pills-today-tab')}
                                                            aria-selected={producttabcategory === "pills-today-tab" ? "true" : "false"}
                                                        >
                                                            Today
                                                            {todayproduct.length > 0 &&
                                                                <span className={`booking-count ${producttabcategory === "pills-today-tab" ? 'bg-white' : 'primary-bg-medium text-light'}`}> {todayproduct.length}</span>
                                                            }
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button
                                                            className={`nav-link ${producttabcategory === "pills-upcoming-tab" ? "active" : ""}`}
                                                            id="pills-upcoming-tab"
                                                            data-bs-toggle="pill"
                                                            data-bs-target="#pills-upcoming"
                                                            type="button"
                                                            role="tab"
                                                            aria-controls="pills-upcoming"
                                                            onClick={() => handleTabChange("Productcategory", 'pills-upcoming-tab')}
                                                            aria-selected={producttabcategory === "pills-upcoming-tab" ? "true" : "false"}
                                                        >
                                                            Upcoming
                                                            {upcomingproduct.length > 0 &&
                                                                <span className={`booking-count ${producttabcategory === "pills-upcoming-tab" ? 'bg-white' : 'primary-bg-medium text-light'}`}> {upcomingproduct.length}</span>
                                                            }
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button
                                                            className={`nav-link ${producttabcategory === "pills-unconfirmed-tab" ? "active" : ""}`}
                                                            id="pills-unconfirmed-tab"
                                                            data-bs-toggle="pill"
                                                            data-bs-target="#pills-unconfirmed"
                                                            type="button"
                                                            role="tab"
                                                            aria-controls="pills-unconfirmed"
                                                            onClick={() => handleTabChange("Productcategory", 'pills-unconfirmed-tab')}
                                                            aria-selected={producttabcategory === "pills-unconfirmed-tab" ? "true" : "false"}
                                                        >
                                                            Unconfirmed
                                                            {unconfirmed?.length > 0 &&
                                                                <span className={`booking-count ${producttabcategory === "pills-unconfirmed-tab" ? 'bg-white' : 'primary-bg-medium text-light'}`}> {unconfirmed?.length}</span>
                                                            }
                                                        </button>
                                                    </li>
                                                </ul>

                                                <div class="tab-content pe-3 ps-3" id="pills-tabContent">
                                                    {/* <div class="tab-pane fade show active" id=" -all" role="tabpanel" aria-labelledby="pills-all-tab" tabindex="0"  > */}
                                                    {isOpen ? (
                                                        <div className={`tab-pane fade ${producttabcategory === "pills-all-tab" ? "show active" : ""}`} id="pills-all" role="tabpanel" aria-labelledby="pills-all-tab" tabIndex="0">
                                                            {userOrders?.length > 0 ? (
                                                                userOrders.map((product, index) => (
                                                                    <div className="tab-pane mt-2" id="pills-all-tab" role="tabpanel" aria-labelledby="pills-all-tab" >
                                                                        <div onClick={() => {
                                                                            if (product.type == 'CART') {
                                                                                navigate("/ReviewPay", { state: { merchantId: product.vendor_id, shipingtype: product.shipping_type, orderType: "booknow" }, })
                                                                                let productCart = {
                                                                                    cartId: product.cart_id,
                                                                                    shipping_type: product.shipping_type,
                                                                                    vendorId: product.vendor_id
                                                                                };
                                                                                localStorage.setItem("productCart", JSON.stringify(productCart));
                                                                            }
                                                                            else if (product.kitchen_id) {
                                                                                navigate(`/order-pass/${product.order_id}`)
                                                                            }
                                                                            else {
                                                                                navigate(`/ProductPass/${product.order_id}`)
                                                                            }
                                                                        }}>
                                                                            {product.kitchen_id ? <AppointmentKitchenCard data={product} /> : <AppointmentProductCard data={product} />}
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                // <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-4">
                                                                //     <HiTicket className="bmno-ticket" />   No products
                                                                // </div>
                                                                <>
                                                                    <div>
                                                                        <Lottie animationData={empotyLottie} />
                                                                    </div>
                                                                    <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-1">
                                                                        <HiTicket className="bmno-ticket" />   No products
                                                                    </div>
                                                                    <ViewHistoryBtn />
                                                                </>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )}

                                                    <div className={`tab-pane fade ${producttabcategory === "pills-today-tab" ? "show active" : ""}`} id="pills-today" role="tabpanel" aria-labelledby="pills-today-tab" tabindex="0">
                                                        {
                                                            todayproduct?.length > 0 ?
                                                                todayproduct.map((product, subindex) => {
                                                                    return (
                                                                        <div onClick={() => {
                                                                            navigate(`/ProductPass/${product.order_id}`)
                                                                        }}>

                                                                            {/* {todayproduct?.} */}
                                                                            <AppointmentProductCard data={product} />

                                                                            {/* <AppointmentKitchenCard data={product} /> */}
                                                                        </div>
                                                                    );
                                                                }) :
                                                                // <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-4">
                                                                //     <HiTicket className="bmno-ticket" />    No delivery products
                                                                // </div>
                                                                <>
                                                                    <div>
                                                                        <Lottie animationData={empotyLottie} />
                                                                    </div>
                                                                    <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-1">
                                                                        <HiTicket className="bmno-ticket" />   No delivery products
                                                                    </div>
                                                                    <ViewHistoryBtn />
                                                                </>
                                                        }
                                                    </div>
                                                    <div className={`tab-pane fade ${producttabcategory === "pills-upcoming-tab" ? "show active" : ""}`} id="pills-upcoming" role="tabpanel" aria-labelledby="pills-upcoming-tab" tabindex="0" >
                                                        {
                                                            upcomingproduct?.length > 0 ?
                                                                upcomingproduct.map((product, subindex) => {
                                                                    return (
                                                                        <div onClick={() => navigate(`/ProductPass/${product.order_id}`)}>
                                                                            <AppointmentProductCard data={product} />
                                                                        </div>
                                                                    )
                                                                }) :
                                                                // <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-4">
                                                                //     <HiTicket className="bmno-ticket" />    No upcoming products
                                                                // </div>
                                                                <>
                                                                    <div>
                                                                        <Lottie animationData={empotyLottie} />
                                                                    </div>
                                                                    <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-1">
                                                                        <HiTicket className="bmno-ticket" />   No upcoming products booking
                                                                    </div>
                                                                    <ViewHistoryBtn />
                                                                </>
                                                        }
                                                    </div>
                                                    <div className={`tab-pane fade ${producttabcategory === "pills-unconfirmed-tab" ? "show active" : ""}`} id="pills-unconfirmed" role="tabpanel" aria-labelledby="pills-unconfirmed-tab" tabindex="0" >
                                                        {

                                                            unconfirmed?.length > 0 ?
                                                                unconfirmed.map((product, subindex) => {
                                                                    return (
                                                                        <div onClick={() => {
                                                                            navigate("/ReviewPay", { state: { merchantId: product.vendor_id, shipingtype: product.shipping_type, orderType: "booknow" }, })
                                                                            let productCart = {
                                                                                cartId: product.cart_id,
                                                                                shipping_type: product.shipping_type,
                                                                                vendorId: product.vendor_id
                                                                            };
                                                                            localStorage.setItem("productCart", JSON.stringify(productCart));
                                                                        }}>
                                                                            <AppointmentProductCard data={product} />
                                                                        </div>
                                                                    );
                                                                }) :
                                                                // <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-4">
                                                                //     <HiTicket className="bmno-ticket" />   No Unconfirmed products
                                                                // </div>
                                                                <>
                                                                    <div>
                                                                        <Lottie animationData={empotyLottie} />
                                                                    </div>
                                                                    <div className="text-center ff-poppins-regular fs-14 secondary-text  pt-1">
                                                                        <HiTicket className="bmno-ticket" />   No unconfirmed products
                                                                    </div>
                                                                    <ViewHistoryBtn />
                                                                </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        }



                                    </div>
                                </div>
                            </div>

                            {/* Book Appointments  */}

                            <div className="primary-bg text-white features" role="button">
                                <div className="d-flex justify-content-between align-items-center">
                                    <img src={p_booking_appointments} width={"75px"} height={"75px"} />
                                    <div className="ff-poppins-semiBold fs-18 text-end">
                                        Book Now
                                        <div className="d-flex justify-content-end">
                                            <div className="bookingManager-clickHere-btn" onClick={() => navigate('/search-store')}>
                                                Click Here
                                                <span>
                                                    <IoIosArrowForward />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ff-poppins-regular fs-11 text-end mt-3">
                                    Skip the queue or avoid the hassle of driving to your appointment.
                                    With Pingle, you can easily check available slots, customize your service,
                                    and book your appointment—all at your convenience!
                                </div>
                            </div>
                            <div className="ps-3 pe-3 pb-3 pt-2">
                                <div className="section-box-2" >
                                    <div className="section-header" onClick={() => toggleAccordion(2)} >
                                        <h4 className="section-header-title">Nearby Available Services & Products</h4>
                                        <div className="recentlySearchedStorebox__divider ms-1 me-1">
                                            {" "}
                                        </div>
                                        <span className="arrow">
                                            {openIndices?.includes(2) ? (
                                                <IoIosArrowDropupCircle />
                                            ) : (
                                                <IoIosArrowDropdownCircle />
                                            )}
                                        </span>
                                    </div>

                                    {openIndices?.includes(2) && (
                                        <div className="grid-box">
                                            {vendorTypes
                                                ?.filter(item => item?.vendor_type_id != 0)
                                                .map((item, index) =>
                                                (
                                                    <div className="searchServiceCard" onClick={() => navigate('/domain-based-fillter',
                                                        { state: { item, fil_location } }
                                                    )}>
                                                        <div className="d-flex justify-content-between">
                                                            <div>
                                                                <h4 className="vendor-domain-subtitle">{item?.sub_title}</h4>
                                                                <p className="vendor-domain-typeName">{item?.vendor_type_name}</p>
                                                            </div>
                                                            <img src={item?.icon} className="vendorCateIcon" height={'42px'} width={'42px'} />
                                                        </div>
                                                    </div>
                                                ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="pb-4  pt-3 ps-4 pe-3">
                                <div className="ff-poppins-medium fs-21">Tutorial</div>
                                <div className="ff-poppins-regular fs-11">
                                    This step-by-step Beginner-friendly tutoial will guide you on how to
                                    use the app and make your first pingle booking.
                                </div>
                            </div>
                            <div className=" ">
                                <div className="tutorialSteps scroller-style-x-new ">
                                    <div className="bg-white tutorialCard">
                                        <div className="ff-poppins-semiBold fs-34 primary-text">01</div>
                                        <div className="ff-poppins-semiBold fs-10 mt-1">Step One</div>
                                        <div className="ff-poppins-semiBold fs-16">Scan</div>
                                        <div className="ff-poppins-regular fs-10 mt-2 text-wrap">
                                            Use the Pingle button to open the QR code scanner to scan the Shop QR code.
                                        </div>
                                    </div>
                                    <div className="bg-white tutorialCard">
                                        <div className="ff-poppins-semiBold fs-34 primary-text">02</div>
                                        <div className="ff-poppins-semiBold fs-10 mt-1">Step Two</div>
                                        <div className="ff-poppins-semiBold fs-16">Select</div>
                                        <div className="ff-poppins-regular fs-10 mt-2 text-wrap">
                                            Click "View Services," then choose your preferred service and time slot.
                                        </div>
                                    </div>
                                    <div className="bg-white tutorialCard">
                                        <div className="ff-poppins-semiBold fs-34 primary-text">03</div>
                                        <div className="ff-poppins-semiBold fs-10 mt-1">Step Three</div>
                                        <div className="ff-poppins-semiBold fs-16">Book</div>
                                        <div className="ff-poppins-regular fs-10 mt-2 text-wrap">
                                            Book and pay. You will receive a ticket, accessible from the Bookings Manager.
                                        </div>
                                    </div>
                                    <div className="bg-white tutorialCard">
                                        <div className="ff-poppins-semiBold fs-34 primary-text">04</div>
                                        <div className="ff-poppins-semiBold fs-10 mt-1">Step Four</div>
                                        <div className="ff-poppins-semiBold fs-16">Redeem</div>
                                        <div className="ff-poppins-regular fs-10 mt-2 text-wrap">
                                            Visit the store at your scheduled time to redeem your ticket or expect the product to be delivered at your doorstep
                                        </div>
                                    </div>
                                    <div className="bg-white tutorialCard">
                                        <div className="ff-poppins-regular fs-14 mt-2 text-wrap">
                                            Note: Bookings are marked missed if you're more than 20 minutes late, and you'll need to reschedule.
                                        </div>
                                    </div>

                                </div>
                                <div className="arrow-controls d-flex justify-content-end mt-2">
                                    <FaArrowLeftLong
                                        className="primary-text me-2 mt-1 arrow-icon"
                                        onClick={() => scrollTutorial("left")}
                                    />
                                    <FaArrowRightLong
                                        className="primary-text me-2 mt-1 arrow-icon"
                                        onClick={() => scrollTutorial("right")}
                                    />
                                </div>



                            </div>



                            <div className="primary-bg text-white features" role="button">
                                <div className="d-flex justify-content-between align-items-center">
                                    <img src={p_booking_messenger} width={"75px"} height={"75px"} />
                                    <div className="ff-poppins-semiBold fs-18 text-end ">
                                        Pingle   Messenger
                                        <div className="d-flex justify-content-end">
                                            <div className="bookingManager-clickHere-btn" onClick={() => navigate('/messenger-list')}>
                                                Click Here
                                                <span>
                                                    <IoIosArrowForward />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ff-poppins-regular fs-11 text-end mt-3">
                                    Got a question? No worries! Our Pingle Messenger is here to assist you in real-time and enhance your app experience.
                                    Simply chat with our bot, like you would with a friend.
                                    And that's not all—you can also message the service provider directly for complete clarity.
                                </div>
                            </div>

                            <div className="white-bg features">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="ff-poppins-semiBold fs-24 primary-text lh-sm">
                                        Reschedule <br /> Appointments
                                    </div>
                                    <img src={p_bookings_resech} width={"75px"} height={"75px"} />
                                </div>
                                <div className="ff-poppins-regular fs-11 mt-3">
                                    Feeling under the weather or wanting to switch up your plans? We’ve all been there—life happens! With Pingle,
                                    you can easily adjust upcoming appointments with just one click. No more waiting on the phone or trying to find a
                                    time that works for everyone. Simply click, select a new time, and reschedule.
                                </div>
                            </div>

                            <div className="primary-bg text-white features" role="button" >
                                <div className="d-flex justify-content-between align-items-center">
                                    <img src={p_booking_loyalty} width={"75px"} height={"75px"} />
                                    <div className="ff-poppins-semiBold fs-18 text-end ">
                                        Loyalty  Points
                                        <div className="d-flex justify-content-end">
                                            <div className="bookingManager-clickHere-btn" onClick={() => navigate('/PinglePoints')}>
                                                Click Here
                                                <span>
                                                    <IoIosArrowForward />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ff-poppins-regular fs-11 text-end mt-3">
                                    Here’s another "ing" we bring to you—saving! With every referral and booking,
                                    you earn Pingle Points that can be redeemed for exciting products in our Reward Store.
                                    Your satisfaction makes it all worthwhile
                                </div>
                            </div>

                            <div className="white-bg features">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="ff-poppins-semiBold fs-18 primary-text lh-sm">
                                        Make <br /> it easy
                                    </div>
                                    <img src={p_bookings_makeItEasy} width={"75px"} height={"75px"} />
                                </div>
                                <div className="ff-poppins-regular fs-11 mt-3">
                                    With Pingle, you can effortlessly connect with your favorite outlets, book appointments, make payments,
                                    earn loyalty points, access exclusive offers & discounts, provide feedback, and even reschedule appointments.
                                    In this busy, fast-paced world, Pingle makes life easier—skip the queue and save time.
                                    Life’s busy, but with Pingle, it’s easy!
                                </div>
                            </div>

                            <div className="primary-bg text-white features" role="button" >
                                <div className="d-flex justify-content-between align-items-center">
                                    <img src={p_bookings_connect} width={"75px"} height={"75px"} />
                                    <div className="ff-poppins-semiBold fs-18 text-end  ">
                                        Connect Directly
                                        <div className="d-flex justify-content-end">
                                            <div className="bookingManager-clickHere-btn" onClick={() => navigate('/chat/PINGLE')}>
                                                Click Here
                                                <span>
                                                    <IoIosArrowForward />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ff-poppins-regular fs-11 text-end mt-3">
                                    Need assistance or want to share your Pingle experience? Reach out to our customer service center
                                    with your booking number to share your query or feedback. Your satisfaction is our top priority.
                                </div>
                            </div>

                            <PingleFooter />
                        </div>

                    </>
                    :
                    <div className='d-flex justify-content-center mt-5'>
                        <div>
                            <Skeleton height={70} width={375} />
                            <Skeleton height={70} width={375} />
                            <Skeleton height={70} width={375} />
                            <Skeleton height={70} width={375} />
                            <Skeleton height={70} width={375} />
                            <Skeleton height={70} width={375} />
                            <Skeleton height={70} width={375} />
                            <Skeleton height={70} width={375} />
                            <Skeleton height={70} width={375} />
                            <Skeleton height={70} width={375} />
                            <Skeleton height={70} width={375} />
                        </div>
                    </div>
            }
            {/* <div className="position-absolute FooterButton_main_div" style={{ bottom: 0, justifyContent: 'center' }}>
                <div className="FooterButton_img_div">
                    <img src={FooterButton} width="100%" height="90" className="FooterButton_img" />
                </div>
                <div className="position-absolute" style={{ bottom: 0, justifyContent: 'center', left: '50%', transform: 'translateX(-50px)', width: 100 }}>
                    <div className="d-flex justify-content-center">
                        <link rel="preload" as="image" href="/path/to/pingleLogoWhite.png"/>

                    </div>
                    <div className="ff-balooPaaji2-semiBold primary-text fs-12 d-flex justify-content-center mb-2">
                        PINGLE SCAN
                    </div>
                </div>
            </div> */}

            <div className="position-absolute FooterButton_main_div" style={{ bottom: 0, justifyContent: "center" }}  >
                <div className="FooterButton_img_div">
                    <img src={FooterButton} width="100%" height="90" className="FooterButton_img" alt="Footer Button" />
                </div>

                <div className="position-absolute" style={{ bottom: 0, justifyContent: "center", left: "50%", transform: "translateX(-50px)", width: 100, }}  >
                    <div className="d-flex justify-content-center">
                        <Link to={"/QRCodeScan"}>
                            <img src={pingleLogoWhite} height={50} width={50} alt="Pingle Logo" className={`primary-bg rounded-circle pingle-logo ${showLogo ? "logo-visible" : ""}`} />
                        </Link>
                    </div>
                    <div className="ff-balooPaaji2-semiBold primary-text fs-12 d-flex justify-content-center mb-2">
                        PINGLE SCAN
                    </div>
                </div>
            </div>

            <div className="modal fade backdrop-bg" id="exampleModal" tabIndex="-1" ref={yetTopayRef} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-sm">
                    <div className="modal-content">
                        <div className="modal-body px-3 pt-4 pb-4">
                            <div className="fs-1 text-center">
                                <FaExclamation className="exclamationIcon primary-text" />
                            </div>
                            <div className="text-center ff-poppins-semiBold fs-5 mb-3">
                                Confirm Booking
                            </div>
                            <div className="text-center ff-poppins-semiBold secondary-text fs-16">
                                Please confirm your booking by completing the payment process.
                            </div>

                            <div className="d-flex justify-content-center mt-3">
                                <button type="button" className=" primary-bg border-none text-white px-5 ff-poppins-semiBold rounded-pill ouline-none"
                                    data-bs-dismiss="modal" onClick={() => handelYettoPay()}
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {
                showPaymentSuccessModal && (<div className="modal-backdrop show"></div>)
            }

            {
                showPaymentSuccessModal && (
                    <div className="modal justify-content-center" tabIndex="-1" style={{ display: 'block' }}>
                        <div className="modal-dialog-centered paymentSuccessModal">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <div className='ff-poppins-semiBold fs-1 primary-text text-center'>
                                        Attention!
                                    </div>
                                    <div className='ff-poppins-regular fs-14 text-center mt-2'>
                                        To proceed further you need to login/register and get access to all the features.
                                    </div>
                                    <div className='d-flex justify-content-center align-items-center mt-1 mb-1' role='button' onClick={() => navigate('/login', { state: { fromGuest: true } })}>
                                        <div className='loginBtn primary-bg text-center text-white p-1 ff-poppins-medium fs-16'>Login</div>
                                    </div>
                                    <div className='d-flex justify-content-center align-items-center' role='button' onClick={handlePaySuccessClose}>
                                        <div className='loginBtn text-center text-secondary p-1 ff-poppins-medium fs-16 secondary-bg-1 mt-2'>Close</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

        </>
    );
};

export default BookingsManager;

